import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import React, { useEffect, useState } from "react";
import { Labeled, ReferenceField, TextField } from "react-admin";
import dataProvider from "server/dataProvider";
import { settings } from "app";
import { useNotifyError } from "utils/useNotifyError";

const OtherUniversityInfo = ({ studentEducationId, reloadKey }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const notifyError = useNotifyError();
  const [otherUniversityInfo, setOtherUniversityInfo] = useState([]);
  const [externalDisciplines, setExternalDisciplines] = useState([]);

  useEffect(() => {
    if (!studentEducationId) return;

    const fetchOtherUniversityInfo = async () => {
      try {
        const { data } = await dataProvider.customRequest(
          studentRequests.getOtherUniversityInfo(studentEducationId),
          null,
          "GET",
        );
        setOtherUniversityInfo(data ?? []);
      } catch (err) {
        notifyError(err);
      }
    };

    fetchOtherUniversityInfo();
  }, [studentEducationId, notifyError]);

  useEffect(() => {
    if (!studentEducationId) return;

    const fetchExternalDisciplines = async () => {
      try {
        const { data } = await dataProvider.customRequest(
          studentRequests.getOtherUniversityExternalDisciplines(studentEducationId),
          null,
          "GET",
        );
        setExternalDisciplines(data ?? []);
      } catch (err) {
        console.error("Error fetching external disciplines", err);
        setExternalDisciplines([]);
      }
    };

    fetchExternalDisciplines();
  }, [studentEducationId, reloadKey]);

  if (!otherUniversityInfo.length) return null;

  return (
    <Accordion sx={{ width: "100%" }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
        <Typography
          fontWeight="bold"
          sx={{ color: "#4E2683" }}
        >
          Данни за друг университет
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ width: "100%" }}>
        {otherUniversityInfo.map(info => (
          <Grid
            key={info.id}
            spacing={2}
            container
            sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
          >
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Университет">
                <TextField
                  source="name"
                  record={info}
                  emptyText="-"
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Държава">
                <ReferenceField
                  source="countryId"
                  reference={administrationRequests.getCountriesSelect()}
                  record={info}
                  link={false}
                  emptyText="-"
                >
                  <TextField source="nameBg" />
                </ReferenceField>
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Населено място">
                <ReferenceField
                  source="settlementId"
                  reference={administrationRequests.getSettlementsSelect()}
                  record={info}
                  link={false}
                  emptyText="-"
                >
                  <TextField source="nameBg" />
                </ReferenceField>
              </Labeled>
            </Grid>
          </Grid>
        ))}
        {externalDisciplines.length > 0 && (
          <>
            <Typography
              fontWeight="bold"
              sx={{ color: "#4E2683", mt: 2, mb: 1 }}
            >
              Дисциплини извън учебния план
            </Typography>
            <Box sx={{ overflowX: "auto" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Наименование</TableCell>
                    <TableCell align="center">Лекции</TableCell>
                    <TableCell align="center">Упражнения</TableCell>
                    <TableCell align="center">Извънаудиторна заетост</TableCell>
                    <TableCell align="center">Курс</TableCell>
                    <TableCell align="center">Оценка</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {externalDisciplines.map(discipline => (
                    <TableRow key={discipline.id}>
                      <TableCell>{discipline.name}</TableCell>
                      <TableCell align="center">{discipline.lecturesHours ?? "-"}</TableCell>
                      <TableCell align="center">{discipline.exercisesHours ?? "-"}</TableCell>
                      <TableCell align="center">{discipline.independentWorkHours ?? "-"}</TableCell>
                      <TableCell align="center">{discipline.course}</TableCell>
                      <TableCell align="center">{discipline.grade ?? "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default OtherUniversityInfo;
